export default {
    "created": "Membrul a fost creat cu succes",
    "updated": "Membrul a fost actualizat cu succes",
    "deleted": "Membrul a fost șters cu succes",
    "restored": "Membrul a fost restaurat cu succes",
}
